// src/com/user_info/UserInfoPasswordOffline.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
//import { styled } from '@mui/material/styles';
import { Button, DialogContent, DialogActions, Grid, CircularProgress } from '@mui/material';
import { AppObject, AppStyle, InputType } from '../../value/AppConst';
import VzmTextField from '../../common/VzmTextField';
import {  ErrorHintBox } from '../../common/VzmStyled';
import InputUtil from '../../value/InputUtil';
import IsValid from '../../value/IsValid';
import InformForgotPassword from '../user_info/InformForgotPassword';
import DraggableEditor from '../../common/DraggableEditor';
import { useSnackbar } from 'notistack';
import { useMutation } from '@apollo/client';
import { CHANGE_PASSWORD_OFFLINE_USER_INFO } from './UserInfoGql';
import { useAlertSetter } from '../../api/app-hook';

const InputMap = {
    // toAdd, toEdit : mark if need to submit for mutation
    userId : {
        id: 'userId', label: '사용자ID',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '25자 이내로 입력하세요.',
        check: (value) => {return IsValid.string(value, 0, 25)},
    },
    password : {
        id: 'password', label: '현재 암호',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '본인 확인을 위해 암호를 입력하세요.',
        check: (value) => {return IsValid.string(value, 8, 50)},
    },
    newPassword : {
        id: 'newPassword', label: '새 암호',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '대문자,소문자,숫자,기호 중 3가지 이상 섞어 8자 이상(개인정보보호법).',
        check: (value) => {return IsValid.passwordStrict(value)},
    },
    passwordConfirm : {
        id: 'passwordConfirm', label: '암호확인',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '암호와 동일하게 입력하세요.',
        check: (value) => {return IsValid.string(value, 8, 50)},
    },
};

/**
 * (USER_INFO) 로그인하지 않은 상태에서 암호 변경
 * 사용자 승인요청 > 사용중지 해제요청
 * 로그인 화면(AppLogin.js) 아래에 있는 버튼을 누르면 활성화 되는 화면 내에 들어감.
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2025-09-19 13:39:47 using DbdbTap
 * https://www.dbdbtap.com
 */
export default function UserInfoPasswordOffline({
    open,
    onClose,
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
        const addAlert = useAlertSetter();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [changePasswordOffline, resultChange] = useMutation(CHANGE_PASSWORD_OFFLINE_USER_INFO, {
        onCompleted: (data, option) => onCompleteChange(data, option),
        onError: (error) => {addAlert({title:"암호변경 오류", message:[error.message]})},
    })

    // const dcTypeCdOptions = ValueMisc.makeCodesToSelectList(codeTree, CodeGroup.DC_TYPE_CD, InputMap.dcTypeCd.id);

    const onCompleteChange = (data, clientOption) => {
        if(data.userInfoChangePasswordOffline.ok) {
            enqueueSnackbar('암호 변경이 완료되었습니다.', {variant: 'success'});
            onClose();
        }
    };

    const onChangeValue = (id, value, error0) => {
        let error = error0;
        if(id===InputMap.passwordConfirm.id) {
            if(value !== input.data.newPassword) {
                error = true;
            }
        }
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, false);
        setInput(newInput);
    };

    const onClickSubmit = () => {
        const dataToSubmit = InputUtil.getDataToSubmit(input.data, InputMap, false);
        changePasswordOffline({variables: {userInfo: dataToSubmit}});
    };

    const askCancel = async () => {
        const confirm = window.confirm("정말 취소하시겠습니까?");
        if(confirm) onClose();
    };

    const onClickCancel = () => {
        if(input.changed) askCancel();
        else onClose();
    };

    // Input field initiallized using getInputField(c,t,i)
    return(
        <DraggableEditor open={open} maxWidth='sm'
            title="암호 변경"
        >
            <DialogContent>
                <Box style={{minWidth: 400}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <VzmTextField
                                dict={InputMap.userId}
                                value={input.data.userId}
                                onChange={onChangeValue}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <VzmTextField
                                dict={InputMap.password}
                                value={input.data.password}
                                onChange={onChangeValue}
                                isPassword={true}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <VzmTextField
                                dict={InputMap.newPassword}
                                value={input.data.newPassword}
                                onChange={onChangeValue}
                                isPassword={true}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <VzmTextField
                                dict={InputMap.passwordConfirm}
                                value={input.data.passwordConfirm}
                                onChange={onChangeValue}
                                isPassword={true}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InformForgotPassword />
                        </Grid>
                    
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions style={{display:'flex'}}>
                {
                    input.errorLabels && input.errorLabels.length > 0
                    ?
                    <ErrorHintBox>
                        확인: {input.errorLabels.join(', ')}
                    </ErrorHintBox>
                    : null
                }
                {
                    resultChange.loading
                    ?
                    <span>
                        <CircularProgress />
                        &nbsp;데이터 저장 중...
                    </span>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={
                                input.hasError || !input.changed
                            }
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                        >변경</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                        >취소</Button>
                    </>
                }
            </DialogActions>
        </DraggableEditor>
    );
}
